import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=a1286c44&scoped=true&"
import script from "./PatientList.vue?vue&type=script&lang=js&"
export * from "./PatientList.vue?vue&type=script&lang=js&"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=a1286c44&prod&lang=css&"
import style1 from "./PatientList.vue?vue&type=style&index=1&id=a1286c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1286c44",
  null
  
)

export default component.exports